import { useClientUser } from '@/hooks';
import React, { useMemo, useState } from 'react';
import { LocationPermissionsTitle, LocationPermissionsTitleSpan, TabCard, CardSubtext, Title } from '../blocks';
import { css } from '@emotion/react';
import { ModalContent, PrimaryButton, SecondaryButton } from '@/styles/blocks';
import { Grid, LinearProgress, MenuItem, Snackbar, TextField, Typography } from '@material-ui/core';
import { useMutation, useQuery } from '@apollo/client';
import { UPDATE_SPECIAL_INSTRUCTIONS_SETTINGS } from './graphql';
import { captureException } from '@sentry/react';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import NavResponsiveModal, { ModalHeader } from '@/components/Navigation/NavResponsiveModal';
import FileDropZone from '@/components/OrderDetailsPage/FileDropZone';
import uploadPhotoAsync from '@/utilities/uploadPhotoAsync';
import * as Sentry from '@sentry/react';
import { CheckCircleOutline } from '@material-ui/icons';
import { colors } from '@/styles';
import { CardTitle } from '../blocks';

const slaTypes = ['curbside', 'firstDrySpace', 'roomOfChoice', 'whiteGlove', 'Return', 'Warehouse Return'];

const slaDisplays = {
    curbside: 'Curbside',
    firstDrySpace: 'First Dry Space',
    roomOfChoice: 'Room of Choice',
    whiteGlove: 'White Glove',
    Return: 'Return',
    'Warehouse Return': 'Warehouse Return',
};

const slaHelperText = {
    Curbside: `Call the customer 30 minutes before arrival. Deliver just inside the front door (not to specific rooms).`,
    'First Dry Space': `Call the customer 30 minutes before arrival.
    Deliver just inside the front door (not to specific rooms).`,
    'Room of Choice': `Call the customer 30 minutes before arrival.
    Deliver just inside the front door (not to specific rooms).`,
    'White Glove': `Call the customer 30 minutes before arrival.
    Deliver just inside the front door (not to specific rooms).`,
    Return: `Call the customer 30 minutes before arrival.
    Deliver just inside the front door (not to specific rooms).`,
    'Warehouse Return': `Call the customer 30 minutes before arrival.
    Deliver just inside the front door (not to specific rooms).`,
};

const SLARequirements = () => {
    const { special_instructions_settings, client_id } = useClientUser();
    const [notification, setNotification] = useState({});

    const [updates, setUpdates] = useState({});

    const SLAs = useMemo(() => {
        return {
            ...special_instructions_settings,
            ...updates,
        };
    }, [special_instructions_settings, updates]);

    const [updateClient, { loading }] = useMutation(UPDATE_SPECIAL_INSTRUCTIONS_SETTINGS);

    const onSave = async () => {
        updateClient({
            variables: {
                client_id: client_id,
                special_instructions_settings: SLAs,
            },
            onCompleted: () => {
                setNotification({
                    severity: 'success',
                    message: 'Successfully updated SLA requirements',
                });
            },
            onError: (error) => {
                captureException(error);
                setNotification({
                    severity: 'error',
                    message: 'Error updating SLA requirements',
                });
            },
        });
    };

    return (
        <>
            <div
                css={css`
                    margin-bottom: 30px;
                    margin-top: 30px;
                `}
            >
                <Title>SLA Requirements</Title>
            </div>
            <TabCard
                css={css`
                    padding: 2rem;
                `}
            >
                <Snackbar open={!!notification.message} handleClose={() => setNotification({})} {...notification} />
                <Grid
                    container
                    direction="column"
                    css={css`
                        flex-wrap: nowrap;
                        gap: 30px;
                    `}
                >
                    {slaTypes.map((slaType) => (
                        <Grid container key={slaType}>
                            <Grid item xs={12}>
                                <CardTitle>{slaDisplays?.[slaType]}</CardTitle>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    // value={SLAs?.[slaType] || special_instructions_settings?.[slaType] || ''}
                                    value={SLAs?.[slaType] || ''}
                                    onChange={(e) => setUpdates({ ...updates, [slaType]: e.target.value })}
                                    multiline={true}
                                    minRows={4}
                                    maxRows={8}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
                <Grid
                    item
                    xs={12}
                    css={css`
                        display: flex;
                        justify-content: flex-end;
                        margin-top: 2rem;
                    `}
                >
                    <PrimaryButton onClick={onSave} disabled={loading}>
                        Save
                    </PrimaryButton>
                </Grid>
            </TabCard>
        </>
    );
};

export default SLARequirements;
